var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.categories),function(ref){
var category = ref.category;
var routes = ref.routes;
return _c('div',{key:category},[_c('h3',{staticClass:"mt-3"},[_vm._v(_vm._s(category))]),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},_vm._l((routes),function(ref){
var to = ref.to;
var title = ref.title;
return _c('v-col',{key:title,attrs:{"cols":12,"sm":6,"md":3}},[_c('v-btn',{attrs:{"color":"primary","to":to,"block":""}},[_vm._v(_vm._s(title))])],1)}),1)],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }